export const invitationsApiQueryKeys = {
  all: () => ['invitations'] as const,
};
